import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener cargados los sistemas pertenecientes a los equipos.',
    'Tener cargadas las tareas de reparación para asociarlas a los puntos de control.'
  ],
  tips: [
    'Los puntos de control se usan para cargarlos a los check list de los equipos y cada punto es algo concreto que el operador revisa: "Nivel de aceite de motor", "Estado de cubiertas".',
    'El tipo define cómo se responde: por condición (Bien / Regular / Mal) o por presencia (Presente / No presente).',
    'Asociar el punto a un sistema y a una tarea permite que las fallas detectadas en un check list, directamente genere una orden de trabajo con las tareas a realizar.',
    'Los sistemas asociados a los puntos de control permiten agruparlos demtrp de los check list.',
  ],
  nextSteps: [
    'Armar las plantillas de check list combinando estos puntos de control.',
    'Asignar la plantilla a los equipos que deban controlarse con ella.',
  ],
};

const ConfiguracionPuntosControl = () => (
  <ConfiguracionBase
    apiEndpoint="catalogo-puntos-control"
    titulo="Puntos de Control"
    descripcion="Puntos de control disponibles para armar plantillas de check list"
    icon="fas fa-list-check"
    compact
    help={HELP}
  />
);

export default ConfiguracionPuntosControl;
